const React = require('react');
const classnames = require('classnames');
const shallowCompare = require('react-addons-shallow-compare');
const helper = require('../../helper/dish-helper.js');
import ebuHelper from '../../helper/Ebu-app-helper';
const defaultShopLogo = require('../../asset/images/shop-logo-default.svg');
const searchLogo = require('../../asset/images/search-white.png');
const shopSelect = require('../../asset/images/shop-switch.svg');
const AdsColumn = require('./ads-column.jsx');
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import ShopDeliveryInfo from './shop-deliverty-info';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import shopMessages from '../../intl/messages/shop';
import globalMessages from '../../intl/messages/global';
import ShopSwiper from '../shop-home/shop-swiper.jsx';

import LanguageRecharge from '../language-recharge/language-recharge';

const config = require('../../config');
const type = helper.getUrlParam('type');
const basicListInfo = localStorage.basicListInfo;
const wayFlag = JSON.parse(basicListInfo || '{}').way; // 自提外送

require('./dish-mesthead.scss');

module.exports = React.createClass({
  displayName: 'DishMesthead',
  propTypes: {
    shopInfo: React.PropTypes.object,
    shopLogo: React.PropTypes.string,
    tableInfo: React.PropTypes.object,
    setSearchPage: React.PropTypes.func,
    isHDL: React.PropTypes.bool,
    operateImgUrl: React.PropTypes.string,
    operateUrl: React.PropTypes.string,
    tsOperateImgUrl: React.PropTypes.string,
    tsOperateUrl: React.PropTypes.string,
    setAllDiscount: React.PropTypes.func.isRequired,
    orderPageImage: React.PropTypes.string,
    isAcceptOrder: React.PropTypes.bool,
    takeawayServiceProps: React.PropTypes.object,
    discountProps: React.PropTypes.object,
    openShopTimeStr: React.PropTypes.string,
    openShopTime: React.PropTypes.object,
    flodUpAppendCss: React.PropTypes.string,
    isShowHalf: React.PropTypes.bool, // 是否显示第二杯半价的信息
  },
  getInitialState() {
    return {
      showOperateImage: true,
      languageSwitch: false,
    };
  },
  componentWillMount() {
    const languageSwitch = sessionStorage.getItem('language_switch');
    this.setState({
      languageSwitch,
    });
  },
  getDefaultProps() {
    return {
      shopInfo: {},
      registered: false,
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  getSendText() {
    const {
      shopInfo: { isToHomeFlag },
      takeawayServiceProps = {},
    } = this.props;
    let sendText = '';

    if (type === 'WM' && ((wayFlag && wayFlag === 'ws') || (!wayFlag && isToHomeFlag))) {
      sendText = <ShopDeliveryInfo takeawayServiceProps={takeawayServiceProps} prefixed />;
    }

    return sendText;
  },
  getShopTimeElement(isShopOpen, isHDL, isAcceptOrder, isEnableShop) {
    const text =
      isEnableShop && isAcceptOrder && isShopOpen ? <FormattedMessage {...shopMessages.openFlag} /> : <FormattedMessage {...shopMessages.closedFlag} />;

    const { tableInfo } = this.props;
    const hasTableInfo = this.detectHasTableInfo(tableInfo);

    return (
      <span className="o-fz--12 shop-time-box">
        <time
          className={classnames('shop-status o-text-ellipsis', {
            'shop-time-close': !isShopOpen,
            // 海底捞的时候，字体减小
            'font-size-hdl': isHDL && hasTableInfo,
          })}
        >
          {text}
          {this.getSendText()}
        </time>
        {hasTableInfo && !isHDL && this.buildTableInfoText(tableInfo, isHDL)}
      </span>
    );
  },
  getJumpToListUrl() {
    let url = '';
    const shopId = helper.getUrlParam('shopId');

    switch (type) {
      case 'TS': {
        // 堂食
        url = `${config.shopTSListURL}?shopId=${shopId}&uniqueId=${type}`;
        break;
      }
      case 'WM': {
        // 外卖
        url = `${config.shopWMListURL}?shopId=${shopId}&uniqueId=${type}`;
        break;
      }
      case 'YD': {
        // 预订
        url = `${config.shopTSListURL}?shopId=${shopId}&uniqueId=${type}`;
        break;
      }
      case 'PD': {
        // 排队
        url = `${config.shopTSListURL}?shopId=${shopId}&uniqueId=${type}`;
        break;
      }
      default:
        break;
    }

    return url;
  },
  setSearchPage(evt, bool) {
    evt.preventDefault();
    const { setSearchPage } = this.props;
    setSearchPage(bool);
  },
  detectHasTableInfo(tableInfo) {
    if (!tableInfo || typeof tableInfo !== 'object') {
      return false;
    }
    return Object.keys(tableInfo).length !== 0;
  },
  buildTableInfoText(tableInfo, isHDL) {
    const hasTableInfo = this.detectHasTableInfo(tableInfo);

    return (
      <span
        className={classnames('table-info o-text-ellipsis', {
          // 海底捞的时候，字体减小
          'font-size-hdl': isHDL && hasTableInfo,
          // 非海底捞的时候，营业状态和桌台信息展示在一行，加上分割线
          'table-info-divider': !isHDL && hasTableInfo,
        })}
      >
        {tableInfo.areaName || ''} {tableInfo.tableName || ''}
      </span>
    );
  },
  jumpToListUrl(shopInfo) {
    if(ebuHelper.isEbuEvn()){
      return;
    }
    if (!shopInfo.isSingleShop) {
      location.href = this.getJumpToListUrl();
    }
  },
  closeOperateImage() {
    this.setState({
      showOperateImage: false,
    });
  },
  render() {
    const {
      shopInfo,
      shopLogo,
      tableInfo,
      isHDL,
      swiperAdImgs, // swiper ad
      setAllDiscount,
      orderPageImage,
      isAcceptOrder,
      takeawayServiceProps,
      discountProps,
      openShopTimeStr,
      openShopTime,
      flodUpAppendCss,
      isShowHalf,
    } = this.props;
    const { showOperateImage } = this.state;
    const { marketList, marketListUpdate, multiMarketing, notice, limitedMarketing } = shopInfo || {};
    const hasTableInfo = this.detectHasTableInfo(tableInfo);
    const isEnableShop = shopInfo.isEnableShop;
    const adsExisted = !!shopInfo.getMarket;
    const orderPageImageObj = orderPageImage ? { backgroundImage: `url("${HttpsProtocolImage.getFinalImageUrl(orderPageImage)}")` } : {};

    return (
      <div
        className={classnames('dish-mesthead o-flex__fixed', {
          'ads-existed': adsExisted,
          'operate-existed': swiperAdImgs && swiperAdImgs.length,
        })}
      >
        <div className="dish-mesthead" style={orderPageImageObj}>
          <div className={`shop shop-container shop-container__${flodUpAppendCss}`}>
            <div className="o-flex shop-header">
              <HttpsProtocolImage alt={formatMessage(globalMessages.shopLogo)} src={shopLogo || defaultShopLogo} className="shop-logo" />
              <div className="shop-business-info-container">
                <div className="shop-title o-text-ellipsis">
                  <span className="of o-text-ellipsis" onTouchTap={() => this.jumpToListUrl(shopInfo)}>
                    {shopInfo.commercialName || ''}
                  </span>
                  {/* 饿了么企餐屏蔽门店切换 */}
                  {(!shopInfo.isSingleShop && !ebuHelper.isEbuEvn()) && (
                    <img alt={formatMessage(globalMessages.shopSwitch)} src={shopSelect} onTouchTap={() => this.jumpToListUrl(shopInfo)} />
                  )}
                  <span className="shop-language">{this.state.languageSwitch === 'true' && <LanguageRecharge />}</span>
                </div>
                {this.getShopTimeElement(shopInfo.openStatus, isHDL, isAcceptOrder, isEnableShop)}
                {hasTableInfo && isHDL && this.buildTableInfoText(tableInfo, isHDL)}
              </div>
              <img src={searchLogo} className="searchlogo" onTouchTap={evt => this.setSearchPage(evt, true)} alt="search" />
            </div>
          </div>
          {adsExisted && (
            <AdsColumn
              isHDL={isHDL}
              shopInfo={shopInfo}
              shopLogo={shopLogo}
              marketList={marketList}
              marketListUpdate={marketListUpdate}
              multiMarketing={multiMarketing}
              limitedMarketing={limitedMarketing}
              notice={notice}
              setAllDiscount={setAllDiscount}
              takeawayServiceProps={takeawayServiceProps}
              openShopTime={openShopTime}
              openShopTimeStr={openShopTimeStr}
              discountProps={discountProps || {}}
              searchTouch={(evt, bool) => this.setSearchPage(evt, bool)}
              flodUpAppendCss={flodUpAppendCss}
              setSearchPage={evt => {
                this.setSearchPage(evt, true);
              }}
              isShowHalf={isShowHalf}
            />
          )}
        </div>

        {swiperAdImgs && swiperAdImgs.length && showOperateImage ? (
          <div className={`operate-image-ad shop-container__${flodUpAppendCss}`}>
            <ShopSwiper shopIntroImgs={swiperAdImgs} imgSize={1} />
          </div>
        ) : null}
        {/* {
          operateImgUrl && showOperateImage &&
            <div className={`operate-image shop-container__${flodUpAppendCss}`}>
              {
                operateUrl ?
                  <a href={operateUrl} title="">
                    <HttpsProtocolImage alt="" src={operateImgUrl} />
                    <i className="o-fz--14 o-ta--c operate-image__close" onTouchTap={this.closeOperateImage}>x</i>
                  </a>
                :
                  <span><HttpsProtocolImage alt="" src={operateImgUrl} /></span>
              }
            </div>
        }
        {
          tsOperateImgUrl && showOperateImage &&
            <div className={`operate-image shop-container__${flodUpAppendCss}`}>
              {
                tsOperateUrl ?
                  <a href={tsOperateUrl} title="">
                    <HttpsProtocolImage alt="" src={tsOperateImgUrl} />
                    <i className="o-fz--14 o-ta--c operate-image__close" onTouchTap={this.closeOperateImage}>x</i>
                  </a>
                :
                  <span><HttpsProtocolImage alt="" src={tsOperateImgUrl} /></span>
              }
            </div>
        } */}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-mesthead.jsx